import { Badge } from '@/components/ui/badge'
import { Tooltip,TooltipContent,TooltipTrigger } from '@/components/ui/tooltip'
import type { CustomerStatus } from '@/types'
import { cn } from '@/lib/utils'

interface CustomerStatusBadgeProps {
  status: CustomerStatus
  className?: string
}

const STATUS_CONFIG: Record<CustomerStatus, { label: string; className: string }> = {
  ACTIVE: {
    label: 'Active',
    className: 'bg-emerald-100 text-emerald-700 hover:bg-emerald-100 dark:bg-emerald-500/15 dark:text-emerald-400',
  },
  FLAGGED: {
    label: 'Flagged',
    className: 'bg-amber-100 text-amber-700 hover:bg-amber-100 dark:bg-amber-500/15 dark:text-amber-400',
  },
  BANNED: {
    label: 'Banned',
    className: 'bg-red-100 text-red-700 hover:bg-red-100 dark:bg-red-500/15 dark:text-red-400',
  },
}

export function CustomerStatusBadge({ status, className }: CustomerStatusBadgeProps) {
  const { label, className: colorClass } = STATUS_CONFIG[status]
  return (
    <Badge className={cn('border-transparent text-xs font-medium', colorClass, className)}>
      {label}
    </Badge>
  )
}

const STATUS_DOT: Record<CustomerStatus, { color: string; label: string }> = {
  ACTIVE: { color: 'bg-emerald-500', label: 'Active' },
  FLAGGED: { color: 'bg-amber-500', label: 'Flagged' },
  BANNED: { color: 'bg-red-500', label: 'Banned' },
}

/** A small colored status dot with a hover tooltip. Requires a TooltipProvider ancestor. */
export function CustomerStatusDot({ status, className }: CustomerStatusBadgeProps) {
  const { color, label } = STATUS_DOT[status]
  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <span className={cn('ml-2 inline-block h-2 w-2 shrink-0 cursor-help rounded-full align-middle', color, className)} />
      </TooltipTrigger>
      <TooltipContent>{label}</TooltipContent>
    </Tooltip>
  )
}
